'use strict';

var LandingPageConstants = [{
  'url': '/workflow/dashboard',
  'name': 'app.dashboard',
  'ifFeatureEnabled': ['REVENUE_OPTIMIZER']
}, {
  'url': '/workflow/pricing-summary',
  'name': 'app.pricing-summary',
  'ifFeatureEnabled': ['DYNAMIC_AVAILABILITY'],
  'ifFeatureDisabled': ['REVENUE_OPTIMIZER']
}, {
  'url': '/workflow/fares-optimizer-analysis',
  'name': 'app.fares-optimizer-analysis',
  'ifFeatureEnabled': ['FARES_OPTIMIZER'],
  'ifFeatureDisabled': ['REVENUE_OPTIMIZER']
}, {
  'url': '/workflow/fo-dashboard',
  'name': 'app.fo-dashboard',
  'ifFeatureEnabled': ['FARES_OPTIMIZER;DASHBOARD']
}];
module.exports = LandingPageConstants;